import html from './audioModule.html';
import {partial} from "../../../../utils/partial";
import {AudioPlayer} from "../../../../modules/audioPlayer";
import Mustache from 'mustache';

export class AudioModule {
  public element: HTMLElement;
  private audioPlayer: AudioPlayer;

  constructor(parentElement, data) {
    this.element = partial(Mustache.render(html, data));
    parentElement.appendChild(this.element);

    this.audioPlayer = new AudioPlayer(this.element);
  }

  public kill() {
    this.audioPlayer.kill();
  }
}